import { FileEntryFM, LucideIconName } from '@bm-js/atlascloud-shared'
import { Icon, ResponsiveImage } from '@bm-js/atlascloud-ui'
import { PropsWithChildren } from 'react'

type Props = {
  file: FileEntryFM
  setSpotlight: (file: FileEntryFM) => void
  openFile: (file: FileEntryFM) => void
}

const MediaItemThumbnail = ({ file, setSpotlight, openFile }: Props) => {
  if (file.type === 'image')
    return (
      <ResponsiveImage
        file={file}
        onClick={() => setSpotlight(file)}
        className={`cursor-pointer w-full object-contain h-32`}
      />
    )

  if (file.type === 'pdf')
    return (
      <Wrapper openFile={() => openFile(file)}>
        <Icon name={LucideIconName.FileText} />
      </Wrapper>
    )
  if (file.type === 'video')
    return (
      <Wrapper openFile={() => setSpotlight(file)}>
        <Icon name={LucideIconName.Clapperboard} />
      </Wrapper>
    )

  return (
    <Wrapper openFile={() => openFile(file)}>
      <Icon name={LucideIconName.Files} />
    </Wrapper>
  )
}

export default MediaItemThumbnail

type PropsWrapper = {
  openFile: () => void
}

const Wrapper = ({ openFile, children }: PropsWithChildren<PropsWrapper>) => {
  return (
    <button
      onClick={openFile}
      className='w-full h-32 flex justify-center items-center'
    >
      {children}
    </button>
  )
}
